export type CategoryOption = {
  label: string;
  goal: string;
};

export type CategoryOptionConfig = {
  heading: string;
  heading_signup: string;
  options: CategoryOption[];
};

export const OTHER_OPTION_LABEL = "Other";
export const OTHER_GOAL_PREFIX = "need help to fix/repair item - ";
export const OTHER_GOAL_PREFIX_LOWER = OTHER_GOAL_PREFIX.toLowerCase();

export const CATEGORY_OPTION_MAP: Record<string, CategoryOptionConfig> = {
  fix: {
    heading: "What needs fixing?",
    heading_signup: "",
    options: [
      {
        label: "Fridge/Freezer",
        goal: "I need to fix/replace my fridge or freezer.",
      },
      {
        label: "Washing Machine",
        goal: "I need to fix/replace my washing machine.",
      },
      {
        label: "Oven/Hob",
        goal: "I need to fix/replace my oven or hob.",
      },
      {
        label: "Boiler/Heater",
        goal: "I need to fix/replace my boiler or heater.",
      },
      {
        label: "Toilet",
        goal: "I need to fix/replace my toilet.",
      },
      {
        label: OTHER_OPTION_LABEL,
        goal: "I need help fixing something else in my home.",
      },
    ],
  },
};

export const isOtherGoalString = (value?: string) => {
  if (!value) {
    return false;
  }
  return value.trim().toLowerCase().startsWith(OTHER_GOAL_PREFIX_LOWER);
};

export const extractOtherGoalText = (value?: string) => {
  if (!value || !isOtherGoalString(value)) {
    return "";
  }
  return value.slice(OTHER_GOAL_PREFIX.length).trim();
};

export const matchCategoryOption = (
  categoryConfig: CategoryOptionConfig | undefined,
  value?: string
): CategoryOption | undefined => {
  if (!value || !categoryConfig) {
    return undefined;
  }
  const normalizedValue = value.trim().toLowerCase();
  const isOtherGoal = isOtherGoalString(value);
  return categoryConfig.options.find((option) =>
    isOtherGoal
      ? option.label.toLowerCase() === OTHER_OPTION_LABEL.toLowerCase()
      : option.label.toLowerCase() === normalizedValue ||
        option.goal.toLowerCase() === normalizedValue
  );
};
